export const DEMONS_ABILITY_RANGE = 3;

export const DEMONS_COMBAT_BONUS_DEBUFF = -1;

export const DEMONS_AMOUNT_FACTOR = 5;